<template>
  <div class="box game" :class="outcomeClass">
    <div class="columns is-gapless">
      <div class="column">
        <div class="game__value game__outcome">
            <div>{{ outcome }}</div>
        </div>
      </div>
      <div class="column">
        <div class="game__value game__league-points">
            <div>{{ leaguePosition.league_points }} LP <span class="game__league-points-change">{{ change }}</span></div>
        </div>
      </div>
      <div class="column">
        <div class="game__value game__rank">
            <div>{{ rank }}</div>
        </div>
      </div>
      <div class="column">
        <div class="game__value game__date">
            <div>{{ trackedAt }}</div>
        </div>
      </div>
      <div class="column">
        <div class="game__value game__score">
          <div class="score__title">Score</div>
          <div class="score__value">{{ leaguePosition.score }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { formatLeaguePositionChange } from '@/utilities'

export default {
  props: {
    leaguePosition: {
      type: Object,
      required: true,
    },
  },

  computed: {
    outcome () {
      return this.leaguePosition.is_win === true ? 'WIN' : 'LOSS'
    },
    outcomeClass () {
      return this.leaguePosition.is_win === true ? 'game--win' : 'game--loss'
    },
    change () {
      if (this.leaguePosition.is_initial) {
        return
      }

      return formatLeaguePositionChange(this.leaguePosition.change)
    },
    rank () {
      let tier = this.leaguePosition.tier
      let division = this.leaguePosition.division

      return ['MASTER', 'CHALLENGER'].includes(tier) ? tier : `${tier} ${division}`
    },
    trackedAt () {
      return moment(this.leaguePosition.created_at).fromNow()
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../sass/variables'
@import '~bulma/sass/utilities/variables'
@import '~bulma/sass/utilities/mixins'

.game
  padding: 0
  font-weight: 600
  border-left: 5px solid grey
  margin-bottom: 1rem

.column:not(:last-child)
  border-bottom: 1px solid $divider-color

.game .column,
.game__value
  display: flex
  flex-direction: column
  justify-content: center
  text-align: center
  padding: .75rem

.game__outcome
  font-size: 1.85rem

.score__value
  line-height: 1

.score__title
  font-size: .9rem
  font-weight: 500
  line-height: 1
  margin-bottom: .2rem

.game--win
  border-color: $win-color
  .game__outcome
    color: $win-color
  .game__league-points-change
    color: $win-color

.game--loss
  border-color: $loss-color
  .game__outcome
    color: $loss-color
  .game__league-points-change
    color: $loss-color

+tablet
  .is-flex
    padding: 1.25rem

  .column:not(:last-child)
    border-bottom: none
    border-right: 1px solid $divider-color

.is-dark
  .column:not(:last-child)
    border-bottom: 1px solid rgba(0,0,0,0.1)

  +tablet
    .column:not(:last-child)
      border-bottom: none
      border-right: 1px solid rgba(0,0,0,0.1)
</style>



// WEBPACK FOOTER //
// LeaguePosition.vue?d40dce34